import { ELevelsActions, LevelsActions } from "@edp-store/actions/levels.actions";
import { ILevelsState, initialLevelsState } from "@edp-store/state/levels.state";

export function levelsReducers(state = initialLevelsState, action: LevelsActions): ILevelsState {
    switch (action.type) {
        case ELevelsActions.SaveUserLevel: {
            return {
                ...state,
                userLevel: action.payload,
                celebration: {
                    canShow: false,
                    celebrationScore: action.payload.celebrationScore,
                },
            };
        }
        case ELevelsActions.SaveHistory: {
            return {
                ...state,
                history: action.payload,
            };
        }
        case ELevelsActions.SetCelebrationScore: {
            return {
                ...state,
                celebration: {
                    ...state.celebration,
                    celebrationScore: action.payload,
                },
            };
        }
        case ELevelsActions.SetShowCelebration: {
            return {
                ...state,
                celebration: {
                    ...state.celebration,
                    canShow: action.payload,
                },
            };
        }
        case ELevelsActions.ResetCelebration: {
            return {
                ...state,
                celebration: {
                    celebrationScore: 0,
                    canShow: false,
                },
            };
        }
        default: {
            return state;
        }
    }
}
